__turbopack_context__.v({
  "card": "styles-module-scss-module__JihnnW__card",
  "cardBody": "styles-module-scss-module__JihnnW__cardBody",
  "cardExcerpt": "styles-module-scss-module__JihnnW__cardExcerpt",
  "cardImage": "styles-module-scss-module__JihnnW__cardImage",
  "cardMeta": "styles-module-scss-module__JihnnW__cardMeta",
  "cardTitle": "styles-module-scss-module__JihnnW__cardTitle",
  "categoryTag": "styles-module-scss-module__JihnnW__categoryTag",
  "filterPill": "styles-module-scss-module__JihnnW__filterPill",
  "filterPillActive": "styles-module-scss-module__JihnnW__filterPillActive",
  "filterRow": "styles-module-scss-module__JihnnW__filterRow",
  "grid": "styles-module-scss-module__JihnnW__grid",
  "tag": "styles-module-scss-module__JihnnW__tag",
  "tagRow": "styles-module-scss-module__JihnnW__tagRow",
});
